<div class='width-1100'>

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>bookmark_border</mat-icon>
        <div>
          <span>Certificados Palestrantes • </span>
          <span>{{title}}&nbsp;</span>
        </div>
      </div>

    </mat-toolbar>
  </mat-card>

  <div class='content'>

    <mat-card style="display: flex; flex-direction: row; justify-content: flex-end">
      <button mat-raised-button (click)='openCertificateConfigDialog()'>
        Configurações
      </button>
    </mat-card>


    <mat-card>

      <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro' autocomplete="off">

      <mat-table [dataSource]="staffDataSource"
        style='height: calc(100vh - 370px);  overflow:auto; margin: 0 0 10px 0;'>

        <ng-container matColumnDef="icon">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon style='color:rgba(0,0,0,.8); font-size:1.4em;'>bookmark_border</mat-icon>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="member_name">
          <mat-header-cell *matHeaderCellDef> Palestrantes </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div style="margin: 15px;">
              <b>{{ element.member_name }}</b>
              <br>
              {{ element.type }}
              <div style='padding: 10px 0 10px 0;'>
                <div>• {{ element.event_name }}</div>
                <div>• {{ element.day_name }}</div>
                <div>• {{ element.activity_name }}</div>
                <div *ngIf="element.topic_name">• {{ element.topic_name }}</div>
              </div>
              <span style="color: darkblue;">{{element.certificate_url}}</span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="viewer">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <a *ngIf="element.certificate_url" matTooltip="Visualizar" target='_blank' href={{element.certificate_url}}>
              <mat-icon>remove_red_eye</mat-icon>
            </a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="selected">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox color='primary' #checkboxStaff (change)='toggleCheckStaff(checkboxStaff.checked)'>
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">

            <mat-checkbox color='primary' [(ngModel)]="element.selected">
            </mat-checkbox>

          </mat-cell>
        </ng-container>

        <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedCertificateStaffColumns">
        </mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedCertificateStaffColumns;">
        </mat-row>

      </mat-table>

    </mat-card>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button mat-raised-button (click)='updateStaffEnrollments()'>
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>


</div>